import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { initialConfig } from './grid-initial-config/initial-config';

@Component({
  selector: 'sl-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sl-grid.component.html',
  styleUrl: './sl-grid.component.scss',
})
export class SlGridComponent {
  @Input()
  sidePadding = initialConfig.sidePadding;
  @Input()
  columnGap = initialConfig.columnGap;
  @Input()
  rowsConfig?: string[];
  @Input()
  totalColumns = initialConfig.totalColumns;
  @Input()
  backgroundColor?: string;

  getRowsConfig(): string {
    if (this.rowsConfig) {
      return this.rowsConfig.join(' ');
    } else return '1fr';
  }

  getTotalColumns() {
    return `repeat(${this.totalColumns}, 1fr)`;
  }

  getSidePadding() {
    return `0px ${this.sidePadding}`;
  }
}
